const state = {
    term: null,
    currentOrderPage : 1,
}
const actions = {

}
const mutations = {
    setOrdersTerm (state, val) {
        state.term = val
    },
    setOrdersCurrentPage (state, val) {
        console.log('setOrdersCurrentPage',val)
        state.currentOrderPage = val
    },
}
export default {
    state,
    mutations,
    actions,
}